import { z, ZodType } from 'zod';
import { Account } from './account';
import { Wallet, walletSchema } from './wallet';

export type AccountTreeValue = {
	parents: string;
	wallets: Wallet[];
} & Account;

export const accountTreeValueSchema: ZodType<AccountTreeValue> = z.object({
	id: z.number(),
	name: z.string(),
	note: z.string().nullable(),
	isLocked: z.boolean(),
	createdAt: z.string(),
	parents: z.string(),
	wallets: z.array(walletSchema),
});
